

import {  Link } from "react-router-dom"
import { Icon, Button as SVAButton, Row, Col, Badge } from 'antd';
import MotelTerrain from '../../terrain/MotelTerrain'
import {SVADFORM,SV_SERVICES, SV_SERVER_ADDRESS, SV_URL} from '../../../constants'
import { Radio } from 'antd'
import CreateAddressFormFormBusCom from './CreateAddressFormBusCom'
import ErrorCom from '../../core/AbodeErrorTag'
import SuccessCom from '../../core/AbodeSuccessTag'
import SVAbodeSpinner from '../../core/SVAbodeSpinner'
//ony sepcific to react-router 4.2.2
//import {browserHistory as history} from 'react-router'

import history from "../../../history"

import '../../../css/svdreact.css'
import '../../../css/svformwerror.css'

const React = require('react')
const _ = require('lodash')
/*
import { createBrowserHistory } from "history"
const history = createBrowserHistory();
*/
let sv_my_data_geo ={}
const HeartSvg = () => (
    <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
      <path d="M923 283.6c-13.4-31.1-32.6-58.9-56.9-82.8-24.3-23.8-52.5-42.4-84-55.5-32.5-13.5-66.9-20.3-102.4-20.3-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5-24.4 23.9-43.5 51.7-56.9 82.8-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3 0.1-35.3-7-69.6-20.9-101.9z" />
    </svg>
  );


const HeartIcon = props => <Icon component={HeartSvg} {...props} />;

class SVAddressontainer extends React.Component {

    constructor(props) {
        super(props)
        let me = this
        this.getAppDetails = this.getAppDetails.bind(this) 
        this.closecbParent = this.closecbParent.bind(this)
        this.closecbParentSuccess = this.closecbParentSuccess.bind(this)
        this.getChildBody = this.getChildBody.bind(this)
        this.getChildContainersDetail = this.getChildContainersDetail.bind(this)
        this.title = 'AddressContainer'
        this.svsubmitparent = this.svsubmitparent.bind(this)
        
      
    }
    closecbParentSuccess(){
      let svCustomerId = this.props.svparams.id
      console.log('svCustomerId*********')
      console.log(svCustomerId)
      history.push(`/myaccountSV/${svCustomerId}/myaddressList`)

    }
    closecbParent(){
      let svCustomerId = this.props.svparams.id
      console.log('svCustomerId*********')
      console.log(svCustomerId)
      history.push(`/myaccountSV/${svCustomerId}/myaddressList`)
    }

    componentWillMount()	{
        console.log('sv--task=--- link sends us params')
        console.log(this.props.svparams)
         //console.log(this.props.svparams.id)
         let id = -1
         let svCustomerId = -14
         if(this.props.svparams){
          id = this.props.svparams.addressId
          svCustomerId = this.props.svparams.id
          console.log(id, svCustomerId)
       
       }else{
        console.log('not called by router we might be creat')
        id = -11;
       }
     
       console.log(this.props);
      
      
       
      console.log('sv-cook********2' )
     


    console.log('sbv--sjourn id ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:'+ id)
       
  
    const { cookies } = this.props;
    this.getAppDetails(id, cookies.get('svt'))
       // this.props.priceAndTexNow(id);
   
			
			
	

	}
    getAppDetails(paramQSpaceId, svtv){
        //loadAddressDet(id)
        let id = -1

        if(paramQSpaceId ){
            id  = parseInt(paramQSpaceId)
        }
        console.log('sv a888adreddcotainer getrs id', id)
        if(id < 0){
            console.log("id*  cerate ******", id)
            this.props.createResetFlagsAddressDet()
        }else{

          console.log("id* addressr det or edit******", id)
          this.props.loadAddressDetSecure(id,svtv)
        }
        
        //this.props.sojDetailsAndImagesSV("mancreek") 
        /*this.props.getSojournDetails("mancreek") */
       
    }
    svsubmitparent(values){
        let me = this
        
      console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^sv submit callback**********parent')
      
      console.log(values)
      let id = -13;
      if(this.props.svparams){
         id = this.props.svparams.id
      
      }else{
       console.log('didnot get customerId from router address cerate error issue')
       id = -11;
      }
      ///essearch/spaceBookNow
      //get props.state 
      //console.log(this.props.my_data_traveller)
      if(values ){
          let full_name = ""
          if(  values[ "fname"]){
            full_name =  values[ "fname"]
          }
          if(  values[ "lname"]){
            full_name =  " " + values[ "lname"]
          }
        values[ "name"] =   values[ "name"] ? values[ "name"]:'ca'
        values[ "state"] =   values[ "state"] ? values[ "state"]:'ca'
        values[ "country"] =   values[ "country"] ? values[ "country"]:'usa'
        values[ "customerId"] =  id
          /*
          values[ "rentcar"] =   values[ "rentcar"] ? "Y":'N'
          values[ "bookTaxi"] =   values[ "bookTaxi"] ? "Y":'N'
          values[ "needFlight"] =   values[ "needFlight"] ? "Y":'N'
          values[ "privateparking"] =   values[ "privateparking"] ? "Y":'N'
          */
          values[ "otherDetails"] =   values[ "otherDetails"] ?  values[ "otherDetails"]:"UI HardCoded SVMed facility"
      }
      let comCardAndTraveller = {
        addressNew : values
       
      }  
      const { cookies } = this.props;
     return this.props.addAddressNowSecure(comCardAndTraveller,cookies.get('svt'))
  
    }
    parentHomeCb(){
      console.log('sv***addressContainerClose')
    }

    getChildBody(){
      const lastestUpdateDate = 'Data Refresh Daily'
      const { title, svsubmitparent} = this
      const {my_data_geo } = this.props
      sv_my_data_geo = my_data_geo
      console.log('svj15***adress my_data_geo', my_data_geo)
      let svCustomerId = -14
      let id = -12
      console.log('sv***getChildBody props')
      console.log(this.props)
      if(this.props.svparams){
        id = this.props.svparams.cardId
        svCustomerId = this.props.svparams.id
        console.log(id, svCustomerId)
     
     }else{
      console.log('not called by router we might be creat')
      id = -11;
     }
      let det = {
          "id": 1,
          "customerId": svCustomerId,
          "fname": "John",
          "lname": "Glen",
          "email": "john123@yahoo.com",
          "address": "12 scotland av",
          "city": "Albany",
          "state": "New York",
          "zip": "12110",
          "country": "USA",
          "isdcode": "+1",
          "phone": "5121234356"
      }
      if (this.props.my_data_addressdet ) {
          det = this.props.my_data_addressdet
          
        
      }
      let hasErrorOrSuccess = false
      const {errob, crudsuccessob} = this.props
      if(this.props.error){
        if(errob && (errob.status > 0 ) && (errob.message.length > 0 )){
          hasErrorOrSuccess = true
        }
        if(crudsuccessob && (crudsuccessob.status ==  200 ) && (crudsuccessob.message.length > 0 )){
          hasErrorOrSuccess = true
        }
      }
      const svmsg = "There is error . Plese try later"
       if(this.props.error && ( hasErrorOrSuccess == true )){
         console.log('sv**container ger errob')
         console.log(this.props)
         
         if(crudsuccessob &&  (crudsuccessob.status == 200)){

          console.log('sv**container ger crud_flag')
          return(
            <div >
                
              <div style={{paddingTop:'10px'}}>
                <SuccessCom  svCustomerId={svCustomerId} closecbParentSuccess={this.closecbParentSuccess} crudsuccessob={this.props.crudsuccessob} ></SuccessCom>
              </div>
              <div style={{paddingTop:'10px'}}>
                  <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/myaccountSV/${svCustomerId}/myaddressList`}> My Reservations   </Link></SVAButton>
              </div>
          
            </div>   
            
          )

         }
         if(errob &&  (errob.status != 200)){
          return (
            <div >
              
                <div style={{paddingTop:'10px'}}>
                  <ErrorCom  svCustomerId={svCustomerId} closecbParent={this.closecbParent} errob={this.props.errob} ></ErrorCom>
                </div>
                <div style={{paddingTop:'10px'}}>
                    <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/myaccountSV/${svCustomerId}/myaddressList`}> My Reservations   </Link></SVAButton>
                </div>
              
            </div>   
              )
        }

       }else if(this.props.loading ){
        console.log('sv**container ger loainf')
        return (

          <div >
          <h3>Spinner*****</h3>
         <div style={{paddingTop:'10px'}}>

         <SVAbodeSpinner />
         </div>
 
      </div>   

        
              )
              /*
       }else if(this.props.crud_flag == 'S'){
        console.log('sv**container ger crud_flag')
        return(
          <div >
              
            <div style={{paddingTop:'10px'}}>
              <SuccessCom  svCustomerId={svCustomerId} closecbParentSuccess={this.closecbParentSuccess} crudsuccessob={this.props.crudsuccessob} ></SuccessCom>
            </div>
            <div style={{paddingTop:'10px'}}>
                <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/myaccountSV/${svCustomerId}/myaddressList`}> My Reservations   </Link></SVAButton>
            </div>
        
          </div>   
          
        )
          
*/

       }else {

        console.log('sv**container ger CreatorModifyForm flad')
        
        console.log('svj15 addresscontainer props track  my_data_geo IMP***')

        console.log(this.props)
        if(sv_my_data_geo && sv_my_data_geo.countryTypes && (sv_my_data_geo.countryTypes.length > 5) ){

          return (
            <div style={{paddingTop:'10px'}}>
                <CreateAddressFormFormBusCom my_data_geo={sv_my_data_geo} det={det}  svsubmitparent={svsubmitparent} onSubmit={svsubmitparent}></CreateAddressFormFormBusCom>
                {/* 
                <PaymentCardFormBusCom  onSubmit={svsubmitparent}   ></PaymentCardFormBusCom>
                     */}
                </div>   
                )
        }else{
          return (
            <div style={{paddingTop:'10px'}}>
                <CreateAddressFormFormBusCom my_data_geo={my_data_geo} det={det}  svsubmitparent={svsubmitparent} onSubmit={svsubmitparent}></CreateAddressFormFormBusCom>
                {/* 
                <PaymentCardFormBusCom  onSubmit={svsubmitparent}   ></PaymentCardFormBusCom>
                     */}
                </div>   
                )
        }
         
       }

    }
    getChildContainersDetail() {
      let  svCustomerId = this.props.svparams.id
       
      return (
        <div className="svr-det-pageWrapper">
            <header className="svr-header1">
                      <h1><span><text style={{color:'#f0d8a9'}}> Address Information </text><Link to={`/myaccountSV/${svCustomerId}/svprofile`}> <Icon  style={{ color: '#eeb838' }} type="home" theme="filled" /> </Link></span> </h1>
            </header>
           {this.getChildBody()}
           
         </div>   
           )   
    }


    render() {
      const lastestUpdateDate = 'Data Refresh Daily'
      const { title, orders} = this

      return (

          
          <div className="col-md-12">

              <MotelTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getChildContainersDetail()}></MotelTerrain>
          </div>
      )

  }

}

export default SVAddressontainer